import React, {useEffect, useState} from 'react'
import {Fragment} from 'react';
import {connect} from 'react-redux';
import {getEvents, getDashboardInfo} from './actions'
import {withRouter, useParams, Switch, Route, Link, useRouteMatch} from "react-router-dom";
import MainPage from "./MainPage";
import classNames from 'classnames';
import Orders from "../orders/Orders";
import Customers from "../customers/Customers";
import Books from "../books/Books";
import Discounts from "../discounts/Discounts";
import BooksSale from "../report/BooksSale";

const Dashboard = (props) => {

    const {id} = useParams();
    const [eventId, setEventId] = useState(id);

    useEffect(() => {
        if (eventId) {
            props.getDashboardInfo(eventId);
        }
    }, [eventId]);

    useEffect(() => {
        if (props.activeEvent) {
            setEventId(props.activeEvent)
        }
    }, [props.activeEvent]);

    let match = useRouteMatch();

    if (!eventId) {
        return null;
    }

    const event = props.events[eventId];

    const menu = [
        {
            name: 'مشتریان',
            link: 'customers',
            component: <Customers />
        },
        {
            name: 'کتاب ها',
            link: 'books',
            component: <Books />
        },
        {
            name: 'سفارش‌ها',
            link: 'orders',
            component: <Orders />
        },
        {
            name: 'تخفیف‌ها',
            link: 'discounts',
            component: <Discounts />
        },
        {
            name: 'گزارش فروش کتاب‌ها',
            link: 'bookSales',
            component: <BooksSale />
        },
    ];


    return (
        <Fragment>
            <div className="contentTitle">
                <div>
                    <span className=" font-size_24 boldFont middleContext">{event.name}</span>
                    <span className="separator"></span>
                    <span className="lightFont">{`از ${event.jalaliStartDate} تا ${event.jalaliEndDate}`}</span>
                </div>
            </div>
            <div className="tabs">
                <ul className='mobileTab'>
                    {menu.map(mi =>
                        <li className={classNames({"active": props.location.pathname.includes(mi.link)})}><Link to={`${match.url}/${mi.link}/${eventId}`}>{mi.name}</Link>
                        </li>
                    )}
                </ul>
            </div>
            <span className="lineSeparator"></span>
            <Switch>
                {menu.map(mi =>
                    <Route path={`${match.path}/${mi.link}/:eventId`}>
                        {mi.component}
                    </Route>
                )}
                <Route path={`${match.path}/:eventId`}>
                    <MainPage eventId={eventId}/>
                </Route>
            </Switch>
        </Fragment>
    );
};

const mapStateToProps = ({events, activeEvent, dashboard}) => ({
    events,
    activeEvent,
    dashboard
});

export default connect(mapStateToProps, {getEvents, getDashboardInfo})(withRouter(Dashboard));